var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[(_vm.semester === 'fall2022')?_c('Fall2022',{attrs:{"team":_vm.team}}):(_vm.semester === 'fall2023')?_c('Fall2023',{attrs:{"team":_vm.team}}):(_vm.semester === 'fall2024')?_c('Fall2024',{attrs:{"team":_vm.team}}):[_c('p',{staticClass:"error-message"},[_vm._v("Invalid Semester!")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }